// https://github.com/aws-amplify/amplify-cli/issues/2420

//###############################################
// runAccountChange
//###############################################
export const searchInboundShipments = /* GraphQL */ `
  query SearchInboundShipments(
    $filter: SearchableInboundShipmentFilterInput
    $sort: SearchableInboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        active
        status
        state
        poNumber
        lotNumber
        railCarNumber
        totalUOM
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        createDateTime
        scheduledDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        collectedDateTime
        daysOnDemurrageClock
        accountName
        accountId
        reloadYardId
        inventories {
          items {
            id
            active
            status
            lotNumber
            poNumber
            quantityAdvised
            quantityReceived
            quantityPrecount
            quantityOnHand
            quantityPhysical
            quantityCommitted
            quantityMismatch
            inventoryUOM
            lotType
            areaId
            zoneId
            productName
            productCode
            productId
            accountName
            accountId
            reloadYardId
            inboundShipmentId
            outboundShipmentId
            inventoryItems {
              items {
                id
                quantityOnHand
                quantityCommitted
                status
                areaId
                zoneId
                aisleId
                locationId
                inboundShipmentId
                outboundShipmentId
                locationFullName
              }
            }
            shipmentLineItems {
              items {
                id
                active
                status
                sortKey
                lotNumber
                poNumber
                totalQuantityToPick
                outboundShipmentId
                accountId
                reloadYardId
                inventoryId
              }
              nextToken
            }
            customFields
            sortKey
          }
          nextToken
        }
        invoiceId
        invoice {
          id
          active
          status
          invoiceNumber
          poNumber
          # railCarNumber
          # pickupNumber
          paymentTerms
          dueDate
          # serviceDate
          sentDate
          # pendingDate
          paidDate
          lineItems {
            items {
              id
            }
            nextToken
          }
          subtotal
          discount
          adjustment
          tax
          total
          balance
          notes
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
        }
        trackCar {
          id
          trackId
          locationFullName
        }
        isCollected
      }
      nextToken
      total
    }
  }
`;

export const searchOutboundShipments = /* GraphQL */ `
  query SearchOutboundShipments(
    $filter: SearchableOutboundShipmentFilterInput
    $sort: SearchableOutboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchOutboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        active
        status
        state
        transfer
        transferToAccountId
        transferToAccountName
        poNumber
        pickupNumber
        carrierName
        bolNumber
        railCarNumber
        mustTarp
        didTarp
        skipSignature
        yardSignatureKey
        carrierSignatureKey
        createDateTime
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        startDateTime
        endDateTime
        departureDateTime
        collectedDateTime
        deliveryDateTime
        daysOnDemurrageClock
        tareWeight
        ladenWeight
        weightUnits
        netWeight
        scaleWeightUnits
        totalUOM
        instructions
        areaId
        zoneId
        isCollected
        # sortKey
        reloadYardCommodityId
        accountName
        accountId
        reloadYardId
        invoiceId
        invoice {
          id
          active
          status
          invoiceNumber
          poNumber
          # railCarNumber
          # pickupNumber
          paymentTerms
          dueDate
          # serviceDate
          sentDate
          # pendingDate
          paidDate
          lineItems {
            items {
              id
            }
            nextToken
          }
          subtotal
          discount
          adjustment
          tax
          total
          balance
          notes
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
        }
        shipmentLineItems {
          items {
            id
            active
            status
            lotNumber
            poNumber
            totalQuantityToPick
            outboundShipmentId
            reloadYardId
            sortKey
            inventoryId
            inventory {
              id
              # productId
              # productCode
              # productName
              reloadYardCommodityId
              quantityOnHand
              quantityCommitted
            }
            inventoryItems {
              items {
                inventoryItem {
                  id
                  quantityOnHand
                  quantityCommitted
                  status
                  locationFullName
                }
                quantityToPick
                status
              }
              nextToken
            }
          }
        }
        trackCar {
          id
          trackId
          locationFullName
        }
        customFields
      }
      nextToken
      total
    }
  }
`;

export const listInboundShipmentsContainerDrop = /* GraphQL */ `
  query ListInboundShipments(
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInboundShipments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        containerDrop
        reloadYardId
        accountId
        accountName
        skipInvoice
        invoiceId
        invoice {
          id
        }
        invoicedServices {
          items {
            id
          }
        }
        # photos {
        #   items {
        #   bucket
        #   region
        #   key
        #   type
        #   createdBy
        #   createdAt
        #   }
        # }
      }
      nextToken
    }
  }
`;

export const listOutboundShipmentsContainerDrop = /* GraphQL */ `
  query ListOutboundShipments(
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOutboundShipments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        containerPickup
        reloadYardId
        skipInvoice
        photos {
          items {
            bucket
            region
            key
            type
            createdBy
            createdAt
          }
        }
      }
      nextToken
    }
  }
`;

export const listOutboundShipmentsSkipInvoice = /* GraphQL */ `
  query ListOutboundShipments(
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOutboundShipments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        containerPickup
        reloadYardId
        accountId
        accountName
        skipInvoice
        invoiceId
        invoice {
          id
        }
        invoicedServices {
          items {
            id
          }
        }
      }
      nextToken
    }
  }
`;

//###############################################
// run_Inventory_backfill
//###############################################
export const searchInventorysBackfill = /* GraphQL */ `
  query SearchInventorys(
    $filter: SearchableInventoryFilterInput
    $sort: SearchableInventorySortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInventorys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        owner
        groups
        active
        status
        lotNumber
        lotType
        accountId
        accountName
        poNumber
        railCarNumber
        productName
        productCode
        productId
        product {
          id
          pcs
        }
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityPhysical
        quantityCommitted
        quantityMismatch
        pcs
        inventoryUOM
        weightUOM
        overShipmentQuantity
        underShipmentQuantity
        otherException
        receivedAt
        depletedAt
        turnDays
        lastOutboundId
        areaId
        area {
          areaType
        }
        zoneId
        aisleList
        sortKey
        reloadYardId
        inboundShipmentId
        # inboundShipment {
        #   status
        #   state
        #   totalUnits
        # }
        history {
          type
          date
          by
          text
        }
        reloadYardCommodityId
        reloadYardCommodity {
          commodity {
            name
            locationLoadType
          }
        }
        inventoryItems {
          items {
            id
            status
            depletedAt
            areaId
            zoneId
            aisleId
            locationId
            inboundShipmentId
            outboundShipmentId
            locationFullName
            location {
              id
              active
              reloadYardId
              name
              type
              areaId
              zoneId
              aisleId
              productId
              sortKey
            }
            quantityOnHand
            quantityCommitted
            otherException
            history {
              date
            }
          }
        }
        shipmentLineItems {
          items {
            id
            owner
            groups
            active
            status
            lotNumber
            poNumber
            totalQuantityToPick
            outboundShipmentId
            outboundShipment {
              departureDateTime
            }
            reloadYardId
            sortKey
            inventoryId
            inventoryItems {
              items {
                id
                shipmentLineItemId
                inventoryItemId
                quantityToPick
                status
              }
            }
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;

export const listInventorysForBackfill = /* GraphQL */ `
  query ListInventories(
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        status
        lotNumber
        lotType
        accountId
        accountName
        poNumber
        railCarNumber
        normalizedPoNumber
        normalizedRailCarNumber
        productId
        productCode
        productName
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityPhysical
        quantityCommitted
        quantityMismatch
        pcs
        inventoryUOM
        weightUOM
        overShipmentQuantity
        underShipmentQuantity
        otherException
        receivedAt
        depletedAt
        lastOutboundId
        product {
          id
          pcs
        }
        areaId
        area {
          areaType
        }
        zoneId
        aisleList
        sortKey
        reloadYardId
        inboundShipmentId
        history {
          type
          date
          by
          text
        }
        reloadYardCommodityId
        reloadYardCommodity {
          commodity {
            name
            locationLoadType
          }
        }
        inventoryItems {
          items {
            id
            status
            depletedAt
            areaId
            zoneId
            aisleId
            locationId
            inboundShipmentId
            outboundShipmentId
            locationFullName
            location {
              id
              active
              reloadYardId
              name
              type
              areaId
              zoneId
              aisleId
              productId
              sortKey
            }
            quantityOnHand
            quantityCommitted
            otherException
            history {
              date
            }
          }
        }
        shipmentLineItems {
          items {
            id
            owner
            groups
            active
            status
            lotNumber
            poNumber
            totalQuantityToPick
            outboundShipmentId
            outboundShipment {
              departureDateTime
              status
            }
            reloadYardId
            sortKey
            inventoryId
            inventoryItems {
              items {
                id
                shipmentLineItemId
                inventoryItemId
                quantityToPick
                status
              }
            }
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listInboundShipmentsForBackfill = /* GraphQL */ `
  query ListInboundShipments(
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInboundShipments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        status
        poNumber
        normalizedPoNumber
        railCarNumber
        normalizedRailCarNumber
        originCarrier
        carrierName
        accountId
        billToAccountId
        reloadYardId
        createDateTime
        notifyDateTime
        placedDateTime
        startDateTime
        endDateTime
        releaseDateTime
        totalUOM
      }
      nextToken
    }
  }
`;

export const listOutboundShipmentsForBackfill = /* GraphQL */ `
  query ListOutboundShipments(
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOutboundShipments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        poNumber
        pickupNumber
        consigneePoNumber
        normalizedPoNumber
        normalizedPickupNumber
        normalizedConsigneePoNumber
        railCarNumber
        normalizedRailCarNumber
        carrier
        carrierName
        totalUOM
        accountId
        billToAccountId
      }
      nextToken
    }
  }
`;

// Candidates for the outbound placement backfill: the placed time used to be
// stored in arrivalDateTime, which now holds the driver gate arrival instead.
// status is selected because it is what separates a real legacy placement from
// a gate check-in — see adminPlacementBackfill.
// Yard-scoped variant of the placement-backfill scan: the
// outboundShipmentByStatus GSI reads one status partition per query instead
// of scanning the whole table. Same selection set as the list query below.
export const outboundShipmentByStatusForPlacementBackfill = /* GraphQL */ `
  query OutboundShipmentByStatus(
    $reloadYardId: ID
    $status: ModelStringKeyConditionInput
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByStatus(
      reloadYardId: $reloadYardId
      status: $status
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        accountName
        status
        active
        poNumber
        pickupNumber
        railCarNumber
        gateCheckInId
        arrivalDateTime
        placementDateTime
        endDateTime
        scheduledDateTime
        createDateTime
      }
      nextToken
    }
  }
`;

export const listOutboundShipmentsForPlacementBackfill = /* GraphQL */ `
  query ListOutboundShipments(
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOutboundShipments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        accountName
        status
        active
        poNumber
        pickupNumber
        railCarNumber
        gateCheckInId
        arrivalDateTime
        placementDateTime
        endDateTime
        scheduledDateTime
        createDateTime
      }
      nextToken
    }
  }
`;

export const listProductsForBackfill = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        defaultUOM
        defaultWeightUOM
        # velocityStats
        totalInventoryQuantity
        totalQuantityOnHand
        totalQuantityCommitted
        lowInventoryThreshold
        lowInventoryAlert
        inventories {
          items {
            id
            quantityOnHand
            quantityCommitted
          }
        }
      }
      nextToken
    }
  }
`;

export const listInventoryItemsForBackfill = /* GraphQL */ `
  query ListInventoryItems(
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventoryItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        status
        unloadedAt
        depletedAt
        areaId
        zoneId
        aisleId
        locationId
        inboundShipmentId
        outboundShipmentId
        locationFullName
        location {
          id
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          aisleId
          productId
          sortKey
        }
        quantityOnHand
        quantityCommitted
        otherException
        history {
          date
        }
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          lotType
          accountId
          accountName
          poNumber
          railCarNumber
          productId
          productCode
          productName
          quantityAdvised
          quantityReceived
          quantityOnHand
          quantityPhysical
          quantityCommitted
          quantityMismatch
          pcs
          inventoryUOM
          weightUOM
          overShipmentQuantity
          underShipmentQuantity
          otherException
          receivedAt
          depletedAt
          lastOutboundId
          product {
            id
            pcs
          }
          areaId
          area {
            areaType
          }
          zoneId
          aisleList
          sortKey
          reloadYardId
          inboundShipmentId
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const inventoryByStatusByLot = /* GraphQL */ `
  query InventoryByStatusByLot(
    $reloadYardId: ID
    $statusLotNumber: ModelInventoryInventoryByStatusByLotCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByStatusByLot(
      reloadYardId: $reloadYardId
      statusLotNumber: $statusLotNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        lotNumber
        lotType
        accountId
        accountName
        poNumber
        railCarNumber
        productName
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityPhysical
        quantityCommitted
        quantityMismatch
        inventoryUOM
        overShipmentQuantity
        underShipmentQuantity
        areaId
        zoneId
        aisleList
        # location {
        #   id
        #   owner
        #   groups
        #   active
        #   reloadYardId
        #   name
        #   type
        #   locationLoad {
        #     other {
        #       selected
        #       capacity
        #     }
        #     pallet {
        #       selected
        #       capacity
        #     }
        #     box {
        #       selected
        #       capacity
        #     }
        #     container {
        #       selected
        #       capacity
        #     }
        #     superSack {
        #       selected
        #       capacity
        #     }
        #   }
        #   areaId
        #   area {
        #     id
        #     owner
        #     groups
        #     active
        #     reloadYardId
        #     name
        #     prefix
        #     areaType
        #     sortKey
        #   }
        #   zoneId
        #   zone {
        #     id
        #     owner
        #     groups
        #     active
        #     reloadYardId
        #     name
        #     prefix
        #     accountId
        #     areaId
        #     zoneType
        #     sortKey
        #   }
        #   aisleId
        #   aisle {
        #     id
        #     owner
        #     groups
        #     active
        #     reloadYardId
        #     name
        #     type
        #     areaId
        #     zoneId
        #     bays
        #     levels
        #     positions
        #     capacityUsed
        #     sortKey
        #     topDownPickOrder
        #   }
        #   bay
        #   level
        #   position
        #   capacityAllocated
        #   capacityUsed
        #   length
        #   width
        #   sortKey
        # }
        outboundShipmentId
        sortKey
        reloadYardId
        inboundShipmentId
        history {
          type
          date
          by
          text
        }
        reloadYardCommodityId
        reloadYardCommodity {
          commodity {
            name
            locationLoadType
          }
        }
        inventoryItems {
          items {
            id
            quantityOnHand
            quantityCommitted
            status
            areaId
            zoneId
            aisleId
            locationId
            outboundShipmentId
            locationFullName
          }
        }
        shipmentLineItems {
          items {
            id
            owner
            groups
            active
            status
            lotNumber
            poNumber
            totalQuantityToPick
            outboundShipmentId
            reloadYardId
            sortKey
            inventoryId
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listInventories = /* GraphQL */ `
  query ListInventories(
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        status
        lotNumber
        lotType
        accountId
        accountName
        poNumber
        railCarNumber
        productId
        productCode
        productName
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityPhysical
        quantityCommitted
        quantityMismatch
        inventoryUOM
        areaId
        zoneId
        aisleList
        outboundShipmentId
        sortKey
        reloadYardId
        inboundShipmentId
        hasException
        photos {
          items {
            bucket
            region
            key
            type
            createdBy
            createdAt
          }
        }
        inboundShipment {
          id
          status
          state
          totalUOM
        }
        history {
          type
          date
          by
          text
        }
        reloadYardCommodityId
        reloadYardCommodity {
          commodity {
            name
            locationLoadType
          }
        }
        inventoryItems {
          items {
            id
            quantityOnHand
            quantityCommitted
            status
            areaId
            zoneId
            aisleId
            locationId
            outboundShipmentId
            locationFullName
            hasException
          }
        }
        shipmentLineItems {
          items {
            id
            owner
            groups
            active
            status
            lotNumber
            poNumber
            totalQuantityToPick
            outboundShipmentId
            reloadYardId
            sortKey
            inventoryId
            inventoryItems {
              items {
                id
                shipmentLineItemId
                inventoryItemId
                quantityToPick
                status
                inventoryItem {
                  id
                  quantityOnHand
                  quantityCommitted
                  status
                  hasException
                }
              }
            }
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

//###############################################
// runLocationAudit
//###############################################
export const listLocations = /* GraphQL */ `
  query ListLocations(
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        active
        name
        type
        areaId
        area {
          id
          active
          reloadYardId
          name
          prefix
          areaType
          sortKey
        }
        zoneId
        zone {
          id
          active
          reloadYardId
          name
          prefix
          accountId
          areaId
          zoneType
          sortKey
        }
        aisleId
        aisle {
          id
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          capacityUsed
          sortKey
          topDownPickOrder
          locationLoad {
            other {
              selected
              capacity
            }
            pallet {
              selected
              capacity
            }
            box {
              selected
              capacity
            }
            container {
              selected
              capacity
            }
            superSack {
              selected
              capacity
            }
            dryBulk {
              selected
              capacity
            }
            liquidBulk {
              selected
              capacity
            }
          }
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        locationLoad {
          other {
            selected
            capacity
          }
          pallet {
            selected
            capacity
          }
          box {
            selected
            capacity
          }
          container {
            selected
            capacity
          }
          superSack {
            selected
            capacity
          }
          dryBulk {
            selected
            capacity
          }
          liquidBulk {
            selected
            capacity
          }
        }
        productId
        sortKey
      }
      nextToken
    }
  }
`;

export const locationBySortKey = /* GraphQL */ `
  query LocationBySortKey(
    $reloadYardId: ID
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationBySortKey(
      reloadYardId: $reloadYardId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        reloadYardId
        name
        type
        areaId
        area {
          id
          active
          reloadYardId
          name
          prefix
          areaType
          sortKey
        }
        zoneId
        zone {
          id
          active
          reloadYardId
          name
          prefix
          accountId
          areaId
          zoneType
          sortKey
        }
        aisleId
        aisle {
          id
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          capacityUsed
          sortKey
          topDownPickOrder
        }
        bay
        level
        position
        capacityAllocated
        capacityUsed
        locationLoad {
          other {
            selected
            capacity
          }
          pallet {
            selected
            capacity
          }
          box {
            selected
            capacity
          }
          container {
            selected
            capacity
          }
          superSack {
            selected
            capacity
          }
          dryBulk {
            selected
            capacity
          }
          liquidBulk {
            selected
            capacity
          }
        }
        productId
        sortKey
      }
      nextToken
    }
  }
`;

export const inventoryItemByAisleByStatusAudit = /* GraphQL */ `
  query InventoryItemByAisleByStatus(
    $aisleId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByAisleByStatus(
      aisleId: $aisleId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        quantityOnHand
        unloadedBy
        unloadedAt
        aisleId
        locationId
        status
        inventory {
          productId
          inventoryUOM
          reloadYardCommodity {
            commodity {
              id
              name
              description
              locationLoadType
            }
          }
        }
      }
      nextToken
    }
  }
`;

//###############################################
// InboundInvoiceReport  /reportInboundInvoices
//###############################################
export const searchInboundInvoices = /* GraphQL */ `
  query SearchInboundShipments(
    $filter: SearchableInboundShipmentFilterInput
    $sort: SearchableInboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        status
        state
        poNumber
        lotNumber
        lotType
        railCarNumber
        totalUOM
        placedDateTime
        accountId
        accountName
        invoiceId
        invoice {
          status
          invoiceNumber
          poNumber
          sentDate
          subtotal
          tax
          total
          balance
          inboundShipmentId
          outboundShipmentId
          lineItems {
            items {
              service {
                name
                description
              }
              quantity
              units
              unitCost
              amount
              itemTax
              serviceNote
            }
            nextToken
          }
          createdAt
        }
        customFields
      }
      nextToken
      total
    }
  }
`;

//###############################################
// OutboundInvoiceReport  /reportOutboundInvoices
//###############################################
export const searchOutboundInvoices = /* GraphQL */ `
  query SearchOutboundShipments(
    $filter: SearchableOutboundShipmentFilterInput
    $sort: SearchableOutboundShipmentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchOutboundShipments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        status
        state
        transfer
        transferToAccountName
        poNumber
        pickupNumber
        bolNumber
        railCarNumber
        departureDateTime
        totalUOM
        accountName
        invoiceId
        invoice {
          status
          invoiceNumber
          poNumber
          sentDate
          subtotal
          tax
          total
          balance
          inboundShipmentId
          outboundShipmentId
          lineItems {
            items {
              service {
                name
                description
              }
              quantity
              units
              unitCost
              amount
              itemTax
              serviceNote
            }
            nextToken
          }
          createdAt
        }
        customFields
        createdAt
      }
      nextToken
      total
    }
  }
`;

//###############################################
// InventoryStorageReport  /reportInventoryStorage
//###############################################
export const inventoryByStatusByAccountIdByProductByLot = /* GraphQL */ `
  query InventoryByStatusByAccountIdByProductByLot(
    $reloadYardId: ID
    $statusAccountIdProductNameLotNumber: ModelInventoryInventoryByStatusByAccountIdByProductByLotCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryByStatusByAccountIdByProductByLot(
      reloadYardId: $reloadYardId
      statusAccountIdProductNameLotNumber: $statusAccountIdProductNameLotNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        quantityOnHand
        quantityPhysical
        inventoryUOM
        weight
        weightUOM
        areaId
        zoneId
        productName
        productCode
        productId
        accountId
      }
      nextToken
    }
  }
`;

//###############################################
// AvgInventoryTurnsByAccount  /reportTurnoverByAccount
//###############################################
export const countInventoryTurns = /* GraphQL */ `
  query SearchInventorys(
    $filter: SearchableInventoryFilterInput
    $sort: SearchableInventorySortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInventorys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        turnDays
      }
      total
    }
  }
`;

export const outboundShipmentByStatusDeleteMe = /* GraphQL */ `
  query OutboundShipmentByStatus(
    $reloadYardId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    outboundShipmentByStatus(
      reloadYardId: $reloadYardId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        status
        state
        poNumber
        accountName
        accountId
        billToAccountId
        reloadYardId
        scheduledDateTime
        arrivalDateTime
        placementDateTime
        endDateTime
        createDateTime
        shipmentLineItems {
          items {
            id
            owner
            groups
            active
            status
            lotNumber
            poNumber
            totalQuantityToPick
            outboundShipmentId
            reloadYardId
            sortKey
            inventoryId
            inventory {
              id
              active
              groups
              reloadYardId
              status
              outboundShipmentId
              productName
              productCode
              productId
              lotType
              lotNumber
              poNumber
              areaId
              zoneId
              inventoryItems {
                items {
                  id
                  quantityOnHand
                  quantityCommitted
                  status
                  areaId
                  zoneId
                  aisleId
                  locationId
                  outboundShipmentId
                  locationFullName
                  latitude
                  longitude
                }
              }
            }
            inventoryItems {
              items {
                id
                groups
                reloadYardId
                outboundShipmentId
                shipmentLineItemId
                inventoryItemId
                quantityToPick
                status
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listInventoryItemsIds = /* GraphQL */ `
  query ListInventoryItems(
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventoryItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        inventoryId
        areaId
        zoneId
        aisleId
        locationId
        outboundShipmentId
        reloadYardId
      }
      nextToken
    }
  }
`;

export const listInventoryItemsDeleteMe = /* GraphQL */ `
  query ListInventoryItems(
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventoryItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        quantityOnHand
        quantityCommitted
        status
        inventoryId
        # inventory {
        #   id
        #   accountId
        #   inboundShipmentId
        #   quantityCommitted
        #   locationId
        #   outboundShipmentId
        #   deliveryDateTime
        #   history {
        #     type
        #     date
        #     by
        #     text
        #   }
        # }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          areaId
          color
          zoneType
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          aisleId
          bay
          level
          position
          capacityUsed
          capacityAllocated
          length
          width
          sortKey
          createdAt
          updatedAt
        }
        outboundShipmentId
        locationFullName
        reloadYardId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listShipmentLineItemInventoryItemsDeleteMe = /* GraphQL */ `
  query ListShipmentLineItemInventoryItems(
    $filter: ModelShipmentLineItemInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShipmentLineItemInventoryItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        groups
        reloadYardId
        outboundShipmentId
        shipmentLineItemId
        inventoryId
        inventoryItemId
        quantityToPick
        status
        createdAt
        updatedAt
        inventoryItem {
          id
          inventory {
            id
          }
        }
      }
      nextToken
    }
  }
`;

//###############################################
// devDeleteEmptyInbounds
//###############################################
export const inboundShipmentByReloadYardByAccount = /* GraphQL */ `
  query InboundShipmentByReloadYardByAccount(
    $reloadYardId: ID
    $accountId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inboundShipmentByReloadYardByAccount(
      reloadYardId: $reloadYardId
      accountId: $accountId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        status
        state
        accountId
        reloadYardId
        inventories {
          items {
            id
            status
            accountId
            accountName
            inboundShipmentId
            reloadYardId
            quantityAdvised
            quantityReceived
            quantityOnHand
            quantityPhysical
            quantityCommitted
            quantityMismatch
            inventoryUOM
            aisleList
            productName
            productCode
            productId
            lotNumber
            lotType
            customFields
            sortKey
            inventoryItems {
              items {
                id
                quantityOnHand
                quantityCommitted
                hasException
                isDamaged
                originOfDamage
                status
                areaId
                zoneId
                aisleId
                locationId
                outboundShipmentId
                locationFullName
                latitude
                longitude
                unloadedBy
                unloadedAt
              }
            }
            shipmentLineItems {
              items {
                id
                groups
                active
                status
                lotNumber
                poNumber
                totalQuantityToPick
                outboundShipmentId
                reloadYardId
                inventoryId
                inventoryItems {
                  items {
                    id
                    groups
                    reloadYardId
                    outboundShipmentId
                    shipmentLineItemId
                    inventoryId
                    inventoryItemId
                    quantityToPick
                    status
                  }
                  nextToken
                }
              }
              nextToken
            }
            notes {
              type
              date
              by
              text
              public
            }
            history {
              type
              date
              by
              text
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;

//###############################################
// fixMissingLocationNames
//###############################################
export const inventoryItemByLocationByStatus = /* GraphQL */ `
  query InventoryItemByLocationByStatus(
    $locationId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    inventoryItemByLocationByStatus(
      locationId: $locationId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        quantityOnHand
        quantityCommitted
        hasException
        isDamaged
        originOfDamage
        otherException
        otherExceptionNote
        status
        accountId
        inboundShipmentId
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          railCarNumber
          receivedAt
          depletedAt
          turnDays
          quantityAdvised
          quantityReceived
          quantityOnHand
          quantityPhysical
          quantityCommitted
          quantityMismatch
          inventoryUOM
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          outboundShipmentId
          productName
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          auditId
          reloadYardCommodityId
          aggregateInventoryId
          customFields
          history {
            type
            date
            by
            text
          }
        }
        barcode
        areaId
        zoneId
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          accountName
          name
          type
          areaId
          area {
            id
            owner
            groups
            active
            reloadYardId
            name
            prefix
            color
            areaType
            sortKey
          }
          zoneId
          zone {
            id
            owner
            groups
            active
            reloadYardId
            name
            prefix
            accountId
            areaId
            color
            zoneType
            reloadYardCommodityId
            sortKey
          }
          aisleId
          aisle {
            id
            active
            reloadYardId
            name
            type
            areaId
            zoneId
            capacityUsed
            sortKey
            topDownPickOrder
          }
          bay
          level
          position
          capacityAllocated
          capacityUsed
          length
          width
          sortKey
          productId
          productName
          bulkCapacity
          bulkUnits
        }
        outboundShipmentId
        locationFullName
        latitude
        longitude
        reloadYardId
        unloadedBy
        unloadedAt
        history {
          type
          date
          by
          text
        }
      }
      nextToken
    }
  }
`;

export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        active
        accountId
        reloadYardId
        productCode
        reloadYardCommodityId
        name
        customFields
      }
      nextToken
    }
  }
`;

export const listAccounts = /* GraphQL */ `
  query ListAccounts(
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        status
        reloadYardId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listInvoices = /* GraphQL */ `
  query ListInvoices(
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        groups
        active
        status
        event
        invoiceNumber
        poNumber
        paymentTermId
        paymentTerms
        dueDate
        sentDate
        paidDate
        lineItems {
          items {
            id
            invoiceId
            serviceId
            service {
              id
              active
              status
              name
            }
            owner
            groups
            quantity
            units
            unitCost
            amount
            itemTax
            taxRate {
              taxCode
              taxRate
            }
            serviceNote
            serviceDate

            inboundShipmentId
            inboundShipment {
              poNumber
              releaseDateTime
            }
            outboundShipmentId
            outboundShipment {
              poNumber
              departureDateTime
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        subtotal
        discount
        adjustment
        tax
        total
        balance
        notes
        customFields
        contact {
          name
          email
          phone
        }
        accountName
        accountId
        account {
          id
          owner
          groups
          active
          status
          lotNumberPrefix
          businessName
          displayName
          paymentTermId
          email
          phone
          fax
          website
          billingAddress {
            name
            street
            city
            state
            zipCode
            country
          }
          billingContacts {
            name
            email
            phone
            description
          }
          billingEmail
          reloadYardId
          invoiceAttachments
          services {
            items {
              id
              active
              status
              name
              description
              taxRate {
                taxCode
                taxRate
              }
              unit
              pcs
              car
              tl
              mbf
              lf
              sf
              sqm
              gal
              l
              lbs
              tn
              cwt
              kg
              mt
            }
          }
          createdAt
          updatedAt
        }
        attachments {
          bucket
          region
          key
          type
        }
        reloadYardId
        reloadYard {
          id
          name
          phone
          fax
          email
          website
          street
          city
          state
          zipCode
          country
          taxRates {
            taxCode
            taxRate
          }
          invoiceNumberPrefix
          invoiceCounter
          remittanceAddress {
            name
            street
            city
            state
            zipCode
            country
          }
          logoImage {
            bucket
            region
            key
          }
        }
        inboundShipmentId
        inboundShipment {
          shipFrom
          carrierName
          railCarNumber
          totalUOM
          tareWeight
          ladenWeight
          scaleWeightUnits
          placedDateTime
          releaseDateTime
          inventories {
            items {
              productCode
              productName
              quantityAdvised
              lotNumber
              customFields
            }
          }
          customFields
        }
        outboundShipmentId
        outboundShipment {
          pickupNumber
          shipTo {
            name
            street
            city
            state
            zipCode
            country
          }
          carrierName
          bolNumber
          railCarNumber
          departureDateTime
          tareWeight
          ladenWeight
          scaleWeightUnits
          totalUOM
          sealNumber
          shipmentLineItems {
            items {
              sortKey
              totalQuantityToPick
              inventoryId
              inventory {
                productCode
                productName
                lotNumber
              }
            }
            nextToken
          }
          customFields
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listInvoiceServices = /* GraphQL */ `
  query ListInvoiceServices(
    $filter: ModelInvoiceServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvoiceServices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        invoiceId
        invoice {
          id
          groups
          active
          status
          invoiceNumber
          externalId
          poNumber
          poNumbers
          railCarNumbers
          pickupNumbers
          paymentTermId
          paymentTerms
          createDateTime
          dueDate
          sentDate
          paidDate
          subtotal
          discount
          adjustment
          tax
          total
          balance
          notes
          customFields
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          outboundShipmentId
          event
          createdAt
          updatedAt
        }
        serviceId
        externalId
        sortKey
        service {
          id
          owner
          groups
          active
          status
          name
          description
          unit
          pcs
          car
          tl
          mbf
          lf
          sf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          accountName
          accountId
          reloadYardId
          createdAt
          updatedAt
        }
        accountId
        reloadYardId
        inboundShipmentId
        outboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          carrierName
          lotType
          railCarNumber
          totalUOM
          skipInvoice
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          receiptNumber
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          stockImport
          hasException
          unsafeShipment
          unsafeShipmentNote
          brokenSeal
          brokenSealNote
          otherException
          otherExceptionNote
          instructions
          checklistId
          accountName
          accountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          containerDrop
          containerNumber
          customFields
          timeslotId
          stepName
          sealNumbers
          createdAt
          updatedAt
        }
        outboundShipment {
          id
          owner
          groups
          active
          status
          state
          transfer
          transferToAccountId
          transferToAccountName
          poNumber
          pickupNumber
          carrierType
          carrierName
          bolNumber
          railCarNumber
          mustTarp
          didTarp
          containerPickup
          skipSignature
          yardSignatureKey
          carrierSignatureKey
          createDateTime
          scheduledDateTime
          arrivalDateTime
          placementDateTime
          startDateTime
          endDateTime
          departureDateTime
          collectedDateTime
          deliveryDateTime
          daysOnDemurrageClock
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          totalUOM
          skipInvoice
          billToAccountId
          sealNumber
          assignedTo
          instructions
          areaId
          zoneId
          isCollected
          # sortKey
          reloadYardCommodityId
          accountName
          accountId
          reloadYardId
          invoiceId
          customFields
          timeslotId
          advisedBy
          stepName
          hasException
          createdAt
          updatedAt
        }
        owner
        groups
        quantity
        units
        unitCost
        amount
        itemTax
        taxRate {
          taxCode
          taxRate
        }
        itemTotal
        serviceNote
        # serviceDate
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

// ##########################################
// Orphan InventoryItem audit (adminOrphanInventoryItems.js).
// Flat selections only: an orphan's `inventory: Inventory!` resolves to null,
// and any selection that walks it gets the whole response rejected.
export const listInventoryItemsOrphanAudit = /* GraphQL */ `
  query ListInventoryItems(
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventoryItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        accountId
        inboundShipmentId
        inventoryId
        outboundShipmentId
        locationId
        locationFullName
        status
        quantityOnHand
        quantityCommitted
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const listInventoryIdsOrphanAudit = /* GraphQL */ `
  query ListInventories(
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
      }
      nextToken
    }
  }
`;

export const getInventoryIdOnly = /* GraphQL */ `
  query GetInventorie($id: ID!) {
    getInventorie(id: $id) {
      id
    }
  }
`;

export const getLocationOrphanAudit = /* GraphQL */ `
  query GetLocation($id: ID!) {
    getLocation(id: $id) {
      id
      name
      type
      active
      locationLoad {
        other {
          selected
        }
        dryBulk {
          selected
        }
        liquidBulk {
          selected
        }
      }
    }
  }
`;

export const getAccountNameOnly = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      id
      businessName
      displayName
    }
  }
`;

export const shipmentLineItemByInventoryItemIdOnly = /* GraphQL */ `
  query ShipmentLineItemByInventoryItem($inventoryItemId: ID, $limit: Int) {
    shipmentLineItemByInventoryItem(
      inventoryItemId: $inventoryItemId
      limit: $limit
    ) {
      items {
        id
        outboundShipmentId
      }
    }
  }
`;

export const sealByReferenceIdIdOnly = /* GraphQL */ `
  query SealByReferenceId($referenceId: ID, $limit: Int) {
    sealByReferenceId(referenceId: $referenceId, limit: $limit) {
      items {
        id
      }
    }
  }
`;

export const barcodeByInventoryItemIdOnly = /* GraphQL */ `
  query BarcodeByInventoryItemByActiveByValue(
    $inventoryItemId: ID
    $limit: Int
  ) {
    barcodeByInventoryItemByActiveByValue(
      inventoryItemId: $inventoryItemId
      limit: $limit
    ) {
      items {
        id
      }
    }
  }
`;
